module.exports = __webpack_public_path__ + "img/icon_complete_no.8b855e15.svg";